import React   from 'react';
import StoryItem from "./components/listing/StoryItem";
import {Row} from "reactstrap";
import StoryNewItem from "./components/listing/StoryNewItem";
const StoriesList = ({result, isLoading, browser, selectStory, selectedStory}) => {

  const handleSelection = (uuid) => {
    if (selectStory) {
      selectStory(uuid)
    }
  }

  return <>
    {!isLoading&&result&&<Row xs={12} md={3}>
      {result.map((story,i)=><div key={story.uuid} className='c-item-wrapper'>
        <StoryItem key={story.uuid}  story={story} onClick={browser?()=>handleSelection(story.uuid):null} selectedStory={selectedStory} /></div>)}
      <div className='c-item-wrapper'><StoryNewItem /></div>
    </Row>}
  </>

};

export default StoriesList;
